import { clsx } from "clsx";
import type { ReactNode } from "react";

type SectionHeadingProps = {
  eyebrow?: string;
  title: ReactNode;
  description?: ReactNode;
  align?: "left" | "center";
  /** `night` for headings on the dark Midnight band. */
  tone?: "light" | "night";
  as?: "h1" | "h2";
};

export function SectionHeading({ eyebrow, title, description, align = "center", tone = "light", as: Tag = "h2" }: SectionHeadingProps) {
  const night = tone === "night";
  return (
    <div className={clsx("max-w-3xl", align === "center" ? "mx-auto text-center" : "text-left")}>
      {eyebrow && <p className={clsx("eyebrow mb-4", night ? "text-nightAccent" : "text-accentStrong")}>{eyebrow}</p>}
      <Tag
        className={clsx(
          "text-balance font-semibold tracking-[-0.035em]",
          Tag === "h1" ? "text-4xl leading-[1.04] sm:text-6xl" : "text-3xl leading-[1.08] sm:text-[2.75rem]",
          night ? "text-white" : "text-ink"
        )}
      >
        {title}
      </Tag>
      {description && (
        <p className={clsx("mt-5 text-pretty text-base leading-relaxed sm:text-lg", night ? "text-nightMuted" : "text-muted")}>{description}</p>
      )}
    </div>
  );
}
